
App.factory('domainService',function($http, $q, $rootScope){
	var service = {},
		deffered,
		canceller;

	//check for domain
	service.checkTld = function(domain) {

		if (deffered) {
			deffered.reject();
		}

		deffered = $q.defer();

		if ($rootScope.anytld.length === 1 && domain.indexOf('.') == -1) {
			// append tld if only one result
			domain = domain + '.' + $rootScope.anytld[0];
        	}

		ajaxCall('/domains/available', 'POST', JSON.stringify({ "domain": domain, "any_tld": $rootScope.anytld }), function(resp){
			deffered.resolve(resp);
		});

		return deffered.promise;
	}

	//stop all http requests
	service.stop = function() {
		if(canceller)
		{
			void 0;
			canceller.resolve();
			deffered.reject();
		}
		$rootScope.ajax = false;
		$rootScope.suggestions = [];
		$rootScope.available = false;
		$rootScope.domainError = false;
	}


	//register domain
	service.registerDomain = function(domain,gapps,category,purpose) {
		if(deffered)
		{
			deffered.reject();
		}

		deffered = $q.defer();

		var data = {
			"domain" : domain,
			"google_apps" : gapps
		}

		if(typeof category != 'undefined' && category != null)
		{
			data.additional_data = {};
			data.additional_data.category = category;
		}

		if(typeof purpose != 'undefined' && purpose != null)
		{
			data.additional_data.purpose = purpose;
		}

		ajaxCall('/register/existing', 'POST', JSON.stringify(data), function(resp){
			deffered.resolve(resp);
		});

		return deffered.promise;
	}

	//simple registration for promo code users
	service.simpleRegisterDomain = function(data) {
		if(deffered)
		{
			deffered.resolve();
		}

		deferred = $q.defer();

		ajaxCall('/register/simple', 'POST', JSON.stringify(data), function(resp){
			deffered.resolve(resp);	
		});
		
		return deffered.promise;
	};

	//simple registration for external/dlp users
	service.externalSignup = function(data) {
		if(deffered)
		{
			deffered.resolve();
		}

        deffered = $q.defer();

		ajaxCall('/domains_external', 'POST', JSON.stringify(data), function(resp){
			deffered.resolve(resp);
		});

		return deffered.promise;
	};


	function ajaxCall(url, method, data, callback) {

		$http.defaults.useXDomain = true;
		$rootScope.ajax = true;

		canceller = $q.defer();

		$http({
			url: POP.apiBaseUrl + url,
			method: method,
			data: data,
			withCredentials: true,
			timeout: canceller.promise,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
			}
		}).success(function(resp) {
			$rootScope.ajax = false;
			callback(resp);
			
		}).error(function(resp) {
			$rootScope.ajax = false;
			callback(resp);
		});

	}

	return service;
});
